var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(!_vm.isGuest)?_c('v-btn',{attrs:{"text":"","dark":""},on:{"click":_vm.openDashboard}},[_c('v-icon',{staticClass:"mr-6"},[_vm._v("mdi-view-dashboard")]),_vm._v("Dashboard")],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }